import { render, staticRenderFns } from "./AmexRechazar.vue?vue&type=template&id=22a6afd4&scoped=true&"
import script from "./AmexRechazar.vue?vue&type=script&lang=js&"
export * from "./AmexRechazar.vue?vue&type=script&lang=js&"
import style0 from "./AmexRechazar.vue?vue&type=style&index=0&id=22a6afd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a6afd4",
  null
  
)

component.options.__file = "AmexRechazar.vue"
export default component.exports